// import ModalRenderContainer from '@components/modal/modal-render-container';
import './index.scss';
import LeftSection from "./left-section";
import RightSection from "./right-section";
import { useState, useCallback, useEffect, memo } from 'react'
// import MaintenencePage from '@pages/shared/maintenence';

const Admin = memo(({ children }) => {

    useEffect(() => {
        // Apply saved theme to body
        const savedTheme = localStorage.getItem("theme") || "orange";
        const body = document.body;
        // Remove all theme classes
        body.classList.remove("theme-purple", "theme-blue", "theme-cyan", "theme-green", "theme-orange", "theme-blush");
        // Add saved theme class
        body.classList.add(`theme-${savedTheme}`);

        // Listen for theme changes
        const handleThemeChange = () => {
            const currentTheme = localStorage.getItem("theme") || "orange";
            body.classList.remove("theme-purple", "theme-blue", "theme-cyan", "theme-green", "theme-orange", "theme-blush");
            body.classList.add(`theme-${currentTheme}`);
        };

        window.addEventListener("storage", handleThemeChange);
        // Also listen to custom event for same-tab theme changes
        window.addEventListener("themeChanged", handleThemeChange);

        return () => {
            window.removeEventListener("storage", handleThemeChange);
            window.removeEventListener("themeChanged", handleThemeChange);
        };
    }, []);

    return (
        <div className="admin-container">
            <LeftSection /> 
         <RightSection>
                {children}

                 {/* <ModalRenderContainer />  */}
             </RightSection> 
        </div>
    );
});
export default Admin;
